<h1>Materiales</h1>
<div class="container">
  <form [formGroup]="filterColumForm" class="form">
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label> Filtro Específico </mat-label>
      <mat-select formControlName="filterDetails" (selectionChange)="cleanFilter()"
        matTooltip="Filtro por una columna de la tabla" matTooltipPosition="above">
        <mat-option value="0">Seleccione...</mat-option>
        <mat-option value="materialGrouping" matTooltip="Filtro por la columna Agrupación" matTooltipPosition="right">Agrupación
        </mat-option>
        <mat-option value="description" matTooltip="Filtro por la columna Descripción" matTooltipPosition="right">Descripción
        </mat-option>
        <mat-option value="reference" matTooltip="Filtro por la columna Referencia" matTooltipPosition="right">Referencia
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always" matTooltip="Valor a filtrar por columna seleccionada"
      matTooltipPosition="above" class="input-width-28vw">
      <mat-label>Valor</mat-label>
      <input matInput placeholder="Valor a filtrar..." formControlName="descriptionFilter" (keyup)="resetPaginator($event)"
        #input2>
      <mat-error *ngIf="filterColumForm.controls['descriptionFilter'].hasError('minlength')">Mínimo 3 caracteres.</mat-error>
      <mat-error *ngIf="filterColumForm.controls['descriptionFilter'].hasError('maxlength')">Máximo 100
        caracteres.</mat-error>
    </mat-form-field>
<button mat-raised-button color="primary" type="button" (click)="applyFilterDetails()"
  [disabled]="disableButtonfilter">Filtrar</button>
</form>
<div class="espacio-div-20"></div>
<form [formGroup]="filterSearchForm" class="form" fxHide.xs fxHide.sm fxHide.md>
  <mat-form-field appearance="outline" floatLabel="always" matTooltip="Filtro por cualquier columna de la tabla"
    matTooltipPosition="above" class="input-width-28vw">
    <mat-label> Filtro General </mat-label>
    <input matInput placeholder="Valor a filtrar..." formControlName="descriptionSearch" (keyup)="resetPaginator($event)"
      #input>
    <mat-error *ngIf="filterSearchForm.controls['descriptionSearch'].hasError('minlength')">Mínimo 3 caracteres.</mat-error>
    <mat-error *ngIf="filterSearchForm.controls['descriptionSearch'].hasError('maxlength')">Máximo 100
      caracteres.</mat-error>
    </mat-form-field>
    <button mat-raised-button color="primary" type="button" (click)="applyFilter()"
      [disabled]="disableButtonSearch">Filtrar</button>
    </form>
</div>
<div class="espacio-div-20" fxHide.lg fxHide.xl></div>
<div class="table-overflow-100">
  <table mat-table cdk-table [dataSource]="dataSourceFilters" matSort matSortActive="reference" matSortDirection="asc"
    matSortDisableClear class="mat-elevation-z8">
    <ng-container matColumnDef="reference">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Referencia </th>
      <td mat-cell *matCellDef="let element" align="center"> {{element.reference}} </td>
      </ng-container>
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Fecha </th>
        <td mat-cell *matCellDef="let element"> {{element.date | date:'dd/MM/yyyy'}} </td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Descripción </th>
        <td mat-cell *matCellDef="let element"> {{element.description}} </td>
      </ng-container>
      <ng-container matColumnDef="unit">
        <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Unidad </th>
        <td mat-cell *matCellDef="let element" align="center"> {{element.unit}} </td>
      </ng-container>
      <ng-container matColumnDef="price">
        <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Precio </th>
        <td mat-cell align="right" *matCellDef="let element"> {{element.price | number:'1.2-2':'es'}} </td>
      </ng-container>
      <ng-container matColumnDef="dollarPrice">
        <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Precio $ </th>
        <td mat-cell align="right" *matCellDef="let element"> {{element.dollarPrice | number:'1.2-2':'es'}} </td>
      </ng-container>
      <ng-container matColumnDef="waste">
        <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Desp. </th>
        <td mat-cell align="right" *matCellDef="let element"> {{element.waste | number:'1.2-2':'es'}} </td>
      </ng-container>
      <ng-container matColumnDef="addedValue">
        <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> V.A.N. </th>
        <td mat-cell align="right" *matCellDef="let element"> {{element.addedValue | number:'1.2-2':'es'}} </td>
      </ng-container>
      <ng-container matColumnDef="materialGrouping">
        <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Agrupación </th>
        <td mat-cell *matCellDef="let element"> {{element.materialGrouping}} </td>
      </ng-container>
      <ng-container matColumnDef="supplierName">
        <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Proveedor </th>
        <td mat-cell *matCellDef="let element"> {{element.supplierName}} </td>
      </ng-container>
      <ng-container matColumnDef="commentary">
        <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Comentario </th>
        <td mat-cell *matCellDef="let element"> {{element.commentary}} </td>
      </ng-container>
      <ng-container matColumnDef="materialFamily">
        <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Familia BCV </th>
        <td mat-cell *matCellDef="let element"> {{element.materialFamily}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="mat-header-medium"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        (click)="verDetalle(row)"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="12">No hay data que filtrar</td>
      </tr>
    </table>
</div>
<mat-paginator #paginator [length]="totalItemsPage" [pageSizeOptions]="[25, 50, 100]"
  showFirstLastButtons></mat-paginator>
